import { SplashScreen } from '../../components/smart/ui/SplashScreen';

/**
 * Smart splash / loading — gallery-static (brandReady so the branded phase
 * is inspectable; no claim / logo fetch).
 */
export const LoadingPage = () => (
  <div className="smart-root">
    <SplashScreen brandReady logoSrc={null} />
  </div>
);
